import { Directive, forwardRef, input } from '@angular/core';
import { SelectOptionBase } from './select-option-base';

@Directive({
  selector: 'soft-select-option-header',
  standalone: true,
  providers: [
    {
      provide: SelectOptionBase,
      useExisting: forwardRef(() => SelectOptionHeaderDirective),
    },
  ],
})
export class SelectOptionHeaderDirective extends SelectOptionBase {
  id = input<string | null>(null);
  text = input<string | null>(null);

  constructor() {
    super();
  }
}
